import moment from "moment";

class CommonFunctions{
    getDateFormat(value){
        return moment(value).format('MMM DD, YYYY');
    }
    getPostDateFormat(value){
        return moment(value).format('Do MMMM, YYYY');
    }
    getPostDateFormat2(value){
        return moment(value).format('Do MMMM');
    }
    getTimeFormat(value){
        return moment(value, 'HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');
    }
    getFormattedTime(value){
        return moment(value, 'HH:mm:ss').format('h:mm A');
    }
    getCurrentTime(value){
        return moment(value, 'HH:mm:ss')
    }

    formatPostTitleForLink(value){
        return value
            .replace(/[,'|:]/g, '')          // Remove commas, pipes, and single quotes
            .replace(/\s+/g, '-')           // Replace spaces with hyphens
            .toLowerCase();                 // Convert to lowercase for consistent URL structure
    };    
}

export default new CommonFunctions